// Review #2 addition, Desktop 3.3.2: "Hide/Show icon on login page is different from
// sign-up page. I prefer the style from the login page." This is that icon, lifted out of
// Login.jsx so there is one of it.
//
// There were three before: this drawing inlined in Login.jsx, an identical copy in
// ResetPassword.jsx, and a pair of exported .svg files used as <img> on Signup.jsx — which
// is why signup looked different. Same shape of problem as the four auth navbars.
const EYE_OFF_PATH =
  'M3 3l18 18M10.5 6.2A10.8 10.8 0 0112 6c7 0 10 6 10 6a17.6 17.6 0 01-3.2 4M6.2 7.6A17.4 17.4 0 002 12s3 6 10 6c1.6 0 3-.3 4.3-.8'

const EyeIcon = ({ open }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden focusable="false">
    {open ? (
      <>
        <path
          d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7z"
          stroke="#7d8c74"
          strokeWidth="1.5"
        />
        <circle cx="12" cy="12" r="3" fill="#7d8c74" />
      </>
    ) : (
      <path d={EYE_OFF_PATH} stroke="#7d8c74" strokeWidth="1.5" strokeLinecap="round" />
    )}
  </svg>
)

export default EyeIcon
